<template>
  <v-dialog
    v-bind:value="isShown"
    persistent
    max-width="fit-content">
    <v-card>
      <v-card-title class="text-h7 justify-center">
        <span>{{ title }}</span>
        <v-btn
          v-if="isShownBtnClose"
          icon
          v-on:click="emitBack">
          <v-icon color="#0389e0">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-actions class="justify-center">
        <v-btn
          v-if="showLeaveButton"
          color="red darken-1"
          text
          v-on:click="emitLeave">{{ leaveButtonTitle }}</v-btn>
        <v-btn
          color="blue darken-1"
          text
          v-on:click="emitConfirm">{{ confirmButtonTitle }}</v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * @description Компонент модального диалога предотвращающий выход.
 */
export default {
  name: 'ModalDialogPreventLeave',
  methods: {
    emitBack() {
      this.$emit('back');
    },
    emitConfirm() {
      this.$emit('save');
    },
    emitLeave() {
      this.$emit('leave');
    },
  },
  props: {
    isShown: { type: Boolean, default: false },
    isShownBtnClose: { type: Boolean, default: false },
    title: { type: String, default: () => 'Сохранить изменения?' },
    confirmButtonTitle: { type: String, default: () => 'Сохранить' },
    leaveButtonTitle: { type: String, default: () => 'Не сохранять' },
    showLeaveButton: { type: Boolean, default: () => true },
  },
};
</script>

<style>
</style>
